// eslint-disable-next-line no-unused-vars
import React from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const SwitcherContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px;
  flex-wrap: wrap;
`;

const SwitcherButton = styled.button`
  color: #fff;
  width: 210px;
  padding: 10px 20px;
  margin: 0 5px;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.3s ease;
  cursor: pointer;


  &.active {
    background-color: #ffcc00;
    color: #000;
  }

  &:hover {
    background-color: #555;
  }
`;

const PolicySwitcher = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // Prüfen, ob ein Button aktiv ist
  const isActive = path => location.pathname === path;

  const handleSwitch = path => {
    sessionStorage.setItem('fromPolicySwitcher', 'true'); // Setzen, dass es vom Switcher kommt
    navigate(path);
  };

  return (
    <SwitcherContainer>
      <SwitcherButton
        className={isActive('/privacy-policy') ? 'active' : ''}
        onClick={() => handleSwitch('/privacy-policy')}
      >
        {t('policySwitcher.privacyPolicy')}
      </SwitcherButton>
      <SwitcherButton
        className={isActive('/terms-of-service') ? 'active' : ''}
        onClick={() => handleSwitch('/terms-of-service')}
      >
        {t('policySwitcher.termsOfService')}
      </SwitcherButton>
      <SwitcherButton
        className={isActive('/refund-policy') ? 'active' : ''}
        onClick={() => handleSwitch('/refund-policy')}
      >
        {t('policySwitcher.refundPolicy')}
      </SwitcherButton>
    </SwitcherContainer>
  );
};

export default PolicySwitcher;
